import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Wind } from "lucide-react";

export default function Login() {
  const { user, login, loading } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-[#0B0E14] text-white flex items-center justify-center relative overflow-hidden px-5">
      <div className="absolute inset-0 dot-grid opacity-40" />
      <div className="absolute -top-40 -right-20 w-[420px] h-[420px] rounded-full blur-3xl opacity-20" style={{ background: "radial-gradient(circle, #F5842B, transparent 70%)" }} />

      <div className="relative glass rounded-3xl p-10 max-w-md w-full text-center" data-testid="login-card">
        <img src="/adj-logo.png" alt="ADJ Academia" className="h-20 w-20 object-contain mx-auto" />
        <h1 className="font-display text-3xl font-extrabold mt-6">{t("login.title")}</h1>
        <p className="text-slate-400 mt-3 text-sm leading-relaxed">{t("login.subtitle")}</p>

        <button onClick={login} className="mt-8 w-full bg-white text-[#0B0E14] font-semibold py-3.5 rounded-full flex items-center justify-center gap-3 hover:bg-slate-100 transition-colors" data-testid="google-login-btn">
          <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1Z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z"/></svg>
          {t("login.google")}
        </button>

        <div className="flex items-center justify-center gap-2 mt-8 text-xs text-slate-500 font-mono tracking-wider">
          <Wind size={13} /> {t("login.tag")}
        </div>
      </div>
    </div>
  );
}
